import { Col, Row } from "@zendeskgarden/react-grid";
import { Component } from "react";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "redux";

import OpportunityService from "../../../../../services/opportunity.service";
import UserService from "../../../../../services/user.service";
import { AuthenticationService } from "../../../../../services/auth.service";
import { AlertService } from "../../../../../services/alert.service";
import { getValidateValue } from "../../../../../actions";

import { UserData, avaliacaoUsuario } from "../../../../../model/user.model";
import { AccordionPanel } from "./styles";
import { t } from "../../../../../translations/translation.service";
import OpportunityCriterias from "../../../../../components/professional/candidate-card/card/components/opportuntity-criterias";


type ComportamentalAdvicePanelState = {
  titleOpportunity: string;
  showEditModal: boolean;
  opportunityInfo: any;
  avaliation: {
    avaliacao: any;
    opportunity: {
      id?: string;
      avaliationCriteria?: any;
    };
    user: any;
    conteudo?: string;
    created: Date;
    _id?: string;
    resultado?: number;
  };
  evaluations: any;
};
class ComportamentalAdvicePanel extends Component<{
  opportunityId: string;
  userAvaliation: avaliacaoUsuario;
  user?: UserData;
  getValidateValue: any;
  readOnly?: boolean;
}, ComportamentalAdvicePanelState> {
  state: ComportamentalAdvicePanelState = {
    titleOpportunity: "",
    showEditModal: false,
    opportunityInfo: {},
    avaliation: {
      avaliacao: {} as any,
      opportunity: {} as any,
      user: AuthenticationService.getUser(),
      conteudo: "",
      created: new Date(),
      _id: this.props.userAvaliation._id,
      resultado: 0,
    },
    evaluations: this.props.userAvaliation,
  };

  async componentDidMount() {
    const { opportunityId } = this.props;
    if (opportunityId) {
      const { data } = await OpportunityService.getOpportunityLiteKanban(opportunityId);
      this.setState({ titleOpportunity: data?.titulo });
    }
  }

setAvaliationCriteria = (criteria: any) => {
  this.setState((prevState) => ({
    avaliation: {
      ...prevState.avaliation,
      opportunity: {
        id: this.props.opportunityId,
        avaliationCriteria: criteria,
      },
      conteudo: criteria.conteudo,
      resultado: criteria.resultado,
      _id: criteria._id ?? prevState.avaliation._id,
    },
  }));
};

  checkText = (text: string) => text.length > 0;

saveChanges = async () => {
  const { user, getValidateValue } = this.props;
  const { avaliation } = this.state;
  const avaliationCriteria = avaliation.opportunity?.avaliationCriteria;

  if (!this.checkText(avaliationCriteria?.conteudo || "")) {
    getValidateValue(true);
    return;
  }

  if (user?.avaliacoesUsuario) {
    const resultado = Number(avaliationCriteria.resultado);
    const created = new Date(avaliationCriteria.created || new Date()).toISOString();

    const updatedEvaluation = {
      ...avaliationCriteria,
      resultado,
      created,
      tipo: "comportamental", 
    };

    const index = user.avaliacoesUsuario.findIndex(
      item => item._id === updatedEvaluation._id
    );

    if (index >= 0) {
      user.avaliacoesUsuario.splice(index, 1, updatedEvaluation);
    } else {
      user.avaliacoesUsuario.push(updatedEvaluation);
    }

    const { displayName, ...userWithoutDisplayName } = user;

    try {
      await UserService.updateUser({
        ...userWithoutDisplayName,
        avaliacoesUsuario: user.avaliacoesUsuario,
      });
      this.setState({
        showEditModal: false,
        evaluations: updatedEvaluation,
      });
      AlertService.success(t("Comportamental do candidato atualizado com sucesso"));
    } catch (err) {
      console.error("Erro ao atualizar comportamento:", err);
      this.setState({ showEditModal: false });
      AlertService.error(t("Erro ao atualizar comportamento do candidato"));
    }
  }
};

  renderModal() {
    const { showEditModal, avaliation } = this.state;
    const { user, opportunityId } = this.props;

    return (
      <Modal
        show={showEditModal}
        onHide={() => this.setState({ showEditModal: false })}
        centered
        size="lg"
      >
        <Modal.Header>
          <h1 className="header-modal-edit">
            {t("Edite o comportamental do Candidato")}
          </h1>
        </Modal.Header>
        <Modal.Body className="modal-body-edit">
          <OpportunityCriterias
            opportunityId={opportunityId}
            dataAvaliationCriteria={this.setAvaliationCriteria}
            userId={user?._id}
            editCriteria={avaliation}
          />
        </Modal.Body>
        <Modal.Footer>
          <button className="modal-footer-save-button" onClick={this.saveChanges}>
            {t("Salvar")}
          </button>
        </Modal.Footer>
      </Modal>
    );
  }

  render() {
    const { evaluations } = this.state;
    const currentUser = AuthenticationService.getUser();

    if (!evaluations?.conteudo) {
      return <></>;
    }

    const date = new Date(evaluations.created);
    const htmlContent = evaluations.conteudo || t("Sem informação");

    return (
      <AccordionPanel>
        <Row>
          <Col size={6} className="pb-2" style={{ borderBottom: "solid 1px #869baf" }}>
            <span>{`Nota: ${evaluations.resultado}`}</span>
          </Col>
          <Col size={6} className="pb-2 text-right" style={{ borderBottom: "solid 1px #869baf" }}>
            <span>{`Data: ${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} | ${evaluations.user?.displayName || ""}`}</span>
          </Col>
        </Row>

        <Row>
          <Col className="pt-2">
            <section
              className="text-behavioral"
              dangerouslySetInnerHTML={{ __html: htmlContent }}
            />
          </Col>
        </Row>

           {!this.props.readOnly && evaluations.user?._id === currentUser?._id && (
          <Row className="mt-3">
            <Col className="text-right">
              <button
                className="editButtonComportamentalAdvice"
                onClick={() => this.setState({ avaliation: { ...evaluations }, showEditModal: true })}
              >
                {t("Editar")}
              </button>
            </Col>
          </Row>
        )}
        
        {this.renderModal()}
      </AccordionPanel>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) =>
  bindActionCreators({ getValidateValue }, dispatch);

export default connect(null, mapDispatchToProps)(ComportamentalAdvicePanel);
